import { countriesList, useSearchParams } from '@cmg/common';
import { PageLayout, Stack } from '@cmg/design-system';
import { xcSelectors } from '@cmg/e2e-selectors';
import React, { useMemo } from 'react';

import { useIsEmeaCountry } from '../../common/hooks/useIsEmeaCountry';
import { OfferingStage } from '../../graphql';
import BasicInfoRoute from '../offering-setup/basic-info/BasicInfoRoute';
import { useCheckPrivatePlacementTrait } from '../offering-setup/basic-info/hooks/useCheckPrivatePlacementTrait';
import { getNavItems } from '../offering-setup/OfferingSetupRoute.model';
import { OfferingSetupNav } from '../offering-setup-next/components/OfferingSetupNav';
import { useConfigurationRouteSettings } from '../offering-setup-next/configuration/hooks/useConfigurationRouteSettings';
import { OfferingDomainObject } from './components/design-system';

const OfferingCreateRoute: React.FC = () => {
  const { searchParams } = useSearchParams();
  const countryCode = searchParams.get('countryCode') ?? countriesList.Usa.countryCode;
  const { isEmea, loading: isEmeaLoading } = useIsEmeaCountry(countryCode);
  const { withOrderBookConfiguration } = useConfigurationRouteSettings();
  const hasPrivatePlacementTrait = useCheckPrivatePlacementTrait();
  const navItems = useMemo(
    () =>
      hasPrivatePlacementTrait
        ? getNavItems({ isPrivatePlacement: true })
        : getNavItems({
            isPrivatePlacement: false,
            withOrderBookConfiguration,
            withUnderwritingTerms: !isEmeaLoading && !isEmea,
          }),
    [hasPrivatePlacementTrait, isEmea, isEmeaLoading, withOrderBookConfiguration]
  );

  return (
    <PageLayout
      data-testid={xcSelectors.offeringScreen.testId}
      flex={1}
      header={
        <OfferingDomainObject
          issuerName="New Offering Draft"
          stage={OfferingStage.Draft}
          isDiscarded={false}
          isAuthor
          isInternal
        />
      }
    >
      <Stack flex={1} flexDirection="row">
        <OfferingSetupNav activeStepId="info" navItems={navItems} />
        <BasicInfoRoute />
      </Stack>
    </PageLayout>
  );
};

export default OfferingCreateRoute;
